module.exports = __webpack_public_path__ + "media/drumRoll.d80407e2.mp3";